"use client"

import { Button } from "@/components/ui/button"
import { Moon } from "lucide-react"

// Dark mode only: the toggle is now a disabled icon for layout consistency.
export function ThemeToggle() {
  return (
    <Button
      variant="ghost"
      size="icon"
      className="rounded-full w-9 h-9 opacity-70 cursor-default"
      aria-label="Dark mode enabled"
      disabled
    >
      <Moon className="h-5 w-5 text-yellow-500" />
      <span className="sr-only">Dark mode enabled</span>
    </Button>
  )
}

